import React from "react";

function OCSFile() {
  return <div>OCSFile</div>;
}

export default OCSFile;
